import { TYPES } from './types';

/**
 * Get model name
 * @param model
 * @returns {string}
 */
export const modelName = (model) =>
    model ? model.prototype[TYPES.NAME] || model[TYPES.NAME] || model.name || model(null) : 'Unknown';
